export const ATPhoneNumber = 'tel:+441442979197';



// WEBPACK FOOTER //
// ./src/utils/constants.js